<div class="kt-portlet">
    <div class="kt-portlet__head  d-flex align-items-center justify-content-between">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Yeni Duyuru Ekle
            </h3>
        </div>
        <button type="button" routerLink="/announcement-list" class="btn btn-secondary mr-3">Geri Dön</button>
    </div>
    <div class="container" style="width: 90%">
        <form class="kt-form kt-form--label-left" [formGroup]="addAnnouncementForm" (ngSubmit)="save()" autocomplete="off">
            <div class="kt-portlet__body">
                
                <div class="form-group">
                    <label class="col-form-label">Duyuru başlığı</label>

                    <input formControlName="title" type="text" class="form-control"
                        placeholder="Duyuru başlığı">
                    <small class="form-text text-warning"
                        *ngIf="f.title.errors?.required">Lütfen duyuru başlığı giriniz!</small>
                    <small class="form-text text-warning"
                        *ngIf="f.title.errors?.maxlength">Lütfen en fazla 100 haneli bir duyuru başlığı giriniz!</small>
                </div>

                <div class="form-group">
                    <label class="col-form-label">Duyuru içeriği</label>

                    <textarea formControlName="description" rows="3" class="form-control"
                        placeholder="Duyuru içeriği"></textarea>
                    <small class="form-text text-warning"
                        *ngIf="f.description.errors?.required">Lütfen duyuru içeriği giriniz!</small>
                    <small class="form-text text-warning"
                        *ngIf="f.description.errors?.maxlength">Lütfen en fazla 500 haneli bir duyuru içeriği giriniz!</small>
                </div>

                <div class="form-group">
                    <label for="status" class="col-form-label">Durum</label>
                    <ng-select name="type" id="status" labelForId="status" bindValue="code"
                        style="width: 100%; padding: 5px; float: left;clear: both;" [items]="status_types" bindLabel="text"
                        placeholder="Durum.." formControlName="status">
                    </ng-select>
                    <small class="form-text text-warning" *ngIf="f.status.errors?.required">Lütfen durum seçiniz!</small>
                </div>  

                <div class="form-group">
                    <label for="validUntil" class="col-form-label">Geçerlilik tarihi</label>
                    <input class="form-control" type="date" id="validUntil"
                        formControlName="validUntil" placeholder="Geçerlilik tarihi" name="validUntil">
                    <small class="form-text text-warning" *ngIf="f.validUntil.errors?.required">Lütfen duyuru geçerlilik
                        tarihinizi giriniz!</small>
                </div>

                <div class="form-group">
                    <label for="roleId" class="col-form-label">Roller</label>
                    <ng-select name="roleId" id="roleId" labelForId="roleId"
                        bindValue="id" style="width: 100%; padding: 5px; float: left;clear: both;" placeholder="Roller" [items]="roles"
                        bindLabel="roleName" [multiple]="true" formControlName="roleIds">
                    </ng-select>
                </div>

                <div class="form-group">
                    <label class="kt-checkbox w-100">
                        <input type="checkbox" name="availableAllUser" class="form-control" formControlName="availableAllUser" [(ngModel)]="announcement.availableAllUser">
                        Bütün gönüllü grubuna mı gönderilsin?
                        <span></span>
                    </label>
                </div>
            </div>
            <div class="kt-portlet__foot">
                <div class="kt-form__actions">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-success" (click)="save()">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>